export default "__VITE_ASSET__a72b5cda__"